module.exports = __webpack_public_path__ + "static/dc-automation-d8088fe7bcd145bcd047f5b4b1da0620.jpg";